
import CreatenewSponsorPaymentBank from "../../../../../component/systemMaster/sponsorBank/sponsorBankPayment/sponsorPaymentBank/createnewSponsorPaymentBank/createnewSponsorPaymentBank"
const CreatenewSponsorPaymentBanks=()=>{
    return <CreatenewSponsorPaymentBank/>
}
export default CreatenewSponsorPaymentBanks;